export const moduleName = 'adminSplitFees'
